export const translations = {
  it: {
    nav: {
      home: "Home",
      products: "Prodotti",
      producers: "Produttori",
      logistics: "Logistica",
      certifications: "Certificazioni",
      about: "Chi siamo",
      contact: "Richiedi quotazione",
      admin: "Admin",
    },
    hero: {
      eyebrow: "Trading di materie prime · America Latina",
      title: "Materie prime selezionate, direttamente dall'origine.",
      subtitle:
        "World Commodity Supply seleziona zucchero di canna, caffè e cacao dai migliori produttori di Colombia, Perù, Ecuador e Repubblica Dominicana. Logistica via mare con MSC, puntualità che si misura in nodi.",
      cta_primary: "Richiedi una quotazione",
      cta_secondary: "Scopri i prodotti",
      stat1_value: "12+",
      stat1_label: "Paesi di destinazione",
      stat2_value: "100%",
      stat2_label: "MSC Sea Freight",
      stat3_value: "30+",
      stat3_label: "Produttori certificati",
    },
    products: {
      eyebrow: "Catalogo",
      title: "Cinque referenze. Una filiera curata.",
      lead: "Selezioniamo unicamente lotti che superano i nostri standard di tracciabilità, umidità, polarizzazione e analisi sensoriale.",
      learn_more: "Dettagli prodotto",
      origin: "Origine",
      packaging: "Confezionamento",
      specs: "Specifiche",
      moq: "Quantità minima",
    },
    producers: {
      eyebrow: "Selezione",
      title: "I produttori che scegliamo.",
      lead: "Visitiamo personalmente piantagioni, raffinerie e centri di fermentazione in Colombia, Perù, Ecuador e Repubblica Dominicana. Lavoriamo solo con realtà che condividono i nostri valori: trasparenza, sostenibilità, qualità costante. Il Brasile resta un riferimento storico del settore, ma a causa dei dazi all'importazione la nostra filiera è interamente extra-Brasile.",
      colombia: "Colombia",
      colombia_desc: "Zucchero di canna bianco, brown e biologico dalla Valle del Cauca; caffè Arabica washed da Huila, Nariño e Antioquia.",
      peru: "Perù",
      peru_desc: "Caffè e cacao biologici certificati da Cajamarca, San Martín e Junín. Filiera tracciata fino al singolo lotto.",
      ecuador: "Ecuador",
      ecuador_desc: "Cacao fino de aroma Nacional e CCN-51 dalle province di Manabí ed Esmeraldas.",
      dominican: "Repubblica Dominicana",
      dominican_desc: "Cacao Hispaniola di altissima qualità, fermentazione lenta e essiccazione naturale al sole.",
    },
    logistics: {
      eyebrow: "Logistica",
      title: "Trasporto via mare. MSC come partner unico.",
      lead: "Affidiamo tutte le spedizioni al network globale di MSC: una scelta che ci garantisce frequenza, copertura e — soprattutto — puntualità documentata.",
      point1_title: "Booking diretto",
      point1_desc: "Accesso prioritario alle partenze settimanali da Cartagena, Buenaventura, Callao, Guayaquil e Caucedo.",
      point2_title: "Tracking end-to-end",
      point2_desc: "Visibilità container 24/7 fino al porto di destinazione europeo o mediterraneo.",
      point3_title: "Documentazione conforme",
      point3_desc: "Phytosanitary, Certificate of Origin, EUR.1, ISO/HACCP: tutto curato dal nostro team.",
    },
    certifications: {
      eyebrow: "Garanzie di qualità",
      title: "Certificazioni di altissima qualità.",
      lead: "Ogni lotto è coperto da certificazioni internazionali su sostenibilità, sicurezza alimentare e tracciabilità. La nostra rete di produttori opera secondo gli standard più rigorosi del settore.",
      items: [
        { code: "EU ORGANIC", desc: "Filiera biologica certificata secondo il regolamento europeo." },
        { code: "USDA ORGANIC", desc: "Standard biologico statunitense per export Nord America." },
        { code: "FAIRTRADE", desc: "Commercio equo e prezzo garantito ai produttori." },
        { code: "BONSUCRO", desc: "Standard mondiale per la canna da zucchero sostenibile." },
        { code: "RAINFOREST ALLIANCE", desc: "Tutela degli ecosistemi tropicali e dei lavoratori." },
        { code: "ISO 22000 / HACCP", desc: "Gestione della sicurezza alimentare end-to-end." },
        { code: "FSSC 22000", desc: "Schema di certificazione GFSI riconosciuto a livello globale." },
        { code: "SMETA · SEDEX", desc: "Audit etico su lavoro, ambiente e business integrity." },
      ],
    },
    about: {
      eyebrow: "Chi siamo",
      title: "Un trader, non un intermediario.",
      body1: "World Commodity Supply nasce dalla volontà di accorciare la distanza tra le piantagioni di Colombia, Perù, Ecuador e Repubblica Dominicana e le industrie alimentari europee. Nessuna catena di brokeraggio: solo il rapporto diretto con i produttori che selezioniamo.",
      body2: "Il nostro team è composto da operatori commodity, esperti di trade finance e specialisti di logistica marittima. Lavoriamo in tre lingue, in tre continenti, su un solo principio: consegnare ciò che è stato promesso, nel giorno promesso.",
    },
    contact: {
      eyebrow: "Richiesta di quotazione",
      title: "Parliamo del tuo prossimo carico.",
      lead: "Compila il modulo: riceverai una proposta entro 48 ore lavorative, completa di prezzo CIF/FOB, lead time e disponibilità.",
      company: "Azienda",
      contact_name: "Nome di contatto",
      email: "Email",
      phone: "Telefono (opzionale)",
      country: "Paese",
      destination_port: "Porto di destinazione",
      product: "Prodotto",
      quantity: "Quantità (tonnellate metriche)",
      incoterm: "Incoterm",
      message: "Note aggiuntive",
      submit: "Invia richiesta",
      sending: "Invio in corso...",
      success_title: "Richiesta ricevuta",
      success_desc: "Grazie. Il nostro team ti risponderà entro 48 ore lavorative.",
      error_title: "Errore",
      error_desc: "Impossibile inviare la richiesta. Riprova tra qualche istante.",
      select_product: "Seleziona un prodotto",
    },
    footer: {
      tagline: "Materie prime sudamericane. Logistica MSC. Promesse mantenute.",
      copyright: "© 2025 World Commodity Supply. Tutti i diritti riservati.",
      sections: "Sezioni",
      contact_title: "Contatti",
      contact_lead: "Scrivici per quotazioni, campioni o partnership commerciali.",
      legal: "Legale",
      privacy: "Privacy",
      terms: "Termini",
    },
    admin: {
      login_title: "Accesso amministratore",
      email: "Email",
      password: "Password",
      sign_in: "Accedi",
      signing_in: "Accesso in corso...",
      invalid: "Credenziali non valide",
      dashboard: "Dashboard quotazioni",
      logout: "Esci",
      filter_all: "Tutte",
      filter_new: "Nuove",
      filter_review: "In revisione",
      filter_archived: "Archiviate",
      mark_review: "Segna in revisione",
      mark_archived: "Archivia",
      mark_new: "Riapri",
      no_quotes: "Nessuna richiesta in questa categoria.",
      company: "Azienda",
      product: "Prodotto",
      quantity: "Quantità",
      country: "Paese",
      received: "Ricevuta",
      status: "Stato",
      details: "Dettagli",
    },
  },
  en: {
    nav: {
      home: "Home",
      products: "Products",
      producers: "Producers",
      logistics: "Logistics",
      certifications: "Certifications",
      about: "About",
      contact: "Request a quote",
      admin: "Admin",
    },
    hero: {
      eyebrow: "Commodity trading · Latin America",
      title: "Hand-picked commodities, straight from the source.",
      subtitle:
        "World Commodity Supply sources cane sugar, coffee and cocoa from the finest producers in Colombia, Peru, Ecuador and the Dominican Republic. Sea freight powered by MSC — punctuality you can measure in knots.",
      cta_primary: "Request a quote",
      cta_secondary: "Explore products",
      stat1_value: "12+",
      stat1_label: "Destination countries",
      stat2_value: "100%",
      stat2_label: "MSC Sea Freight",
      stat3_value: "30+",
      stat3_label: "Certified producers",
    },
    products: {
      eyebrow: "Catalogue",
      title: "Five references. One curated supply chain.",
      lead: "We only ship lots that pass our traceability, moisture, polarisation and sensory standards.",
      learn_more: "Product details",
      origin: "Origin",
      packaging: "Packaging",
      specs: "Specifications",
      moq: "Minimum order",
    },
    producers: {
      eyebrow: "Selection",
      title: "The producers we choose.",
      lead: "We personally visit plantations, mills and fermentation centers across Colombia, Peru, Ecuador and the Dominican Republic. We only work with partners who share our values: transparency, sustainability, consistent quality. Brazil remains a historical reference for the industry but, due to import duties, our supply chain is entirely outside Brazil.",
      colombia: "Colombia",
      colombia_desc: "White, brown and organic cane sugar from the Valle del Cauca; washed Arabica coffee from Huila, Nariño and Antioquia.",
      peru: "Peru",
      peru_desc: "Certified organic coffee and cocoa from Cajamarca, San Martín and Junín. Fully lot-traceable.",
      ecuador: "Ecuador",
      ecuador_desc: "Fino de aroma Nacional & CCN-51 cocoa from Manabí and Esmeraldas.",
      dominican: "Dominican Republic",
      dominican_desc: "Premium Hispaniola cocoa, slow fermentation and natural sun-drying.",
    },
    logistics: {
      eyebrow: "Logistics",
      title: "Sea freight. MSC as our single partner.",
      lead: "All shipments move on MSC's global network — giving us frequency, coverage and, above all, documented punctuality.",
      point1_title: "Direct booking",
      point1_desc: "Priority access to weekly departures from Cartagena, Buenaventura, Callao, Guayaquil and Caucedo.",
      point2_title: "End-to-end tracking",
      point2_desc: "24/7 container visibility all the way to the European or Mediterranean port.",
      point3_title: "Compliant paperwork",
      point3_desc: "Phytosanitary, Certificate of Origin, EUR.1, ISO/HACCP — all handled in-house.",
    },
    certifications: {
      eyebrow: "Quality guarantees",
      title: "Highest-grade certifications.",
      lead: "Every lot is covered by international certifications on sustainability, food safety and traceability. Our producer network operates by the most rigorous industry standards.",
      items: [
        { code: "EU ORGANIC", desc: "Certified organic supply chain under EU regulation." },
        { code: "USDA ORGANIC", desc: "US organic standard for North-American export." },
        { code: "FAIRTRADE", desc: "Fair trade with a guaranteed price for producers." },
        { code: "BONSUCRO", desc: "Global standard for sustainable sugar cane." },
        { code: "RAINFOREST ALLIANCE", desc: "Tropical ecosystem and worker protection." },
        { code: "ISO 22000 / HACCP", desc: "End-to-end food safety management." },
        { code: "FSSC 22000", desc: "GFSI-recognised certification scheme." },
        { code: "SMETA · SEDEX", desc: "Ethical audit on labour, environment and integrity." },
      ],
    },
    about: {
      eyebrow: "About us",
      title: "A trader, not a middleman.",
      body1: "World Commodity Supply exists to shorten the distance between the plantations of Colombia, Peru, Ecuador and the Dominican Republic and European food industries. No brokerage chain — just direct relationships with the producers we hand-pick.",
      body2: "Our team blends commodity traders, trade-finance experts and maritime logistics specialists. We work across three languages and three continents on a single principle: deliver what was promised, on the day promised.",
    },
    contact: {
      eyebrow: "Quote request",
      title: "Let's talk about your next cargo.",
      lead: "Fill in the form and you will receive a CIF/FOB offer with lead time and availability within 48 working hours.",
      company: "Company",
      contact_name: "Contact name",
      email: "Email",
      phone: "Phone (optional)",
      country: "Country",
      destination_port: "Destination port",
      product: "Product",
      quantity: "Quantity (metric tons)",
      incoterm: "Incoterm",
      message: "Additional notes",
      submit: "Send request",
      sending: "Sending...",
      success_title: "Request received",
      success_desc: "Thank you. Our team will get back to you within 48 working hours.",
      error_title: "Error",
      error_desc: "Could not submit your request. Please try again shortly.",
      select_product: "Select a product",
    },
    footer: {
      tagline: "South American commodities. MSC logistics. Promises kept.",
      copyright: "© 2025 World Commodity Supply. All rights reserved.",
      sections: "Sections",
      contact_title: "Contact",
      contact_lead: "Write to us for quotes, samples or trade partnerships.",
      legal: "Legal",
      privacy: "Privacy",
      terms: "Terms",
    },
    admin: {
      login_title: "Administrator login",
      email: "Email",
      password: "Password",
      sign_in: "Sign in",
      signing_in: "Signing in...",
      invalid: "Invalid credentials",
      dashboard: "Quotes dashboard",
      logout: "Sign out",
      filter_all: "All",
      filter_new: "New",
      filter_review: "In review",
      filter_archived: "Archived",
      mark_review: "Mark in review",
      mark_archived: "Archive",
      mark_new: "Reopen",
      no_quotes: "No requests in this category.",
      company: "Company",
      product: "Product",
      quantity: "Quantity",
      country: "Country",
      received: "Received",
      status: "Status",
      details: "Details",
    },
  },
  es: {
    nav: {
      home: "Inicio",
      products: "Productos",
      producers: "Productores",
      logistics: "Logística",
      certifications: "Certificaciones",
      about: "Nosotros",
      contact: "Solicitar cotización",
      admin: "Admin",
    },
    hero: {
      eyebrow: "Trading de commodities · América Latina",
      title: "Materias primas seleccionadas, directo desde el origen.",
      subtitle:
        "World Commodity Supply selecciona azúcar de caña, café y cacao de los mejores productores de Colombia, Perú, Ecuador y República Dominicana. Logística marítima con MSC: puntualidad que se mide en nudos.",
      cta_primary: "Solicitar cotización",
      cta_secondary: "Ver productos",
      stat1_value: "12+",
      stat1_label: "Países de destino",
      stat2_value: "100%",
      stat2_label: "MSC Sea Freight",
      stat3_value: "30+",
      stat3_label: "Productores certificados",
    },
    products: {
      eyebrow: "Catálogo",
      title: "Cinco referencias. Una cadena curada.",
      lead: "Solo embarcamos lotes que superan nuestros estándares de trazabilidad, humedad, polarización y análisis sensorial.",
      learn_more: "Detalles del producto",
      origin: "Origen",
      packaging: "Empaque",
      specs: "Especificaciones",
      moq: "Pedido mínimo",
    },
    producers: {
      eyebrow: "Selección",
      title: "Los productores que elegimos.",
      lead: "Visitamos personalmente plantaciones, ingenios y centros de fermentación en Colombia, Perú, Ecuador y República Dominicana. Solo trabajamos con socios que comparten nuestros valores: transparencia, sostenibilidad, calidad constante. Brasil sigue siendo una referencia histórica del sector, pero debido a los aranceles de importación nuestra cadena es totalmente fuera de Brasil.",
      colombia: "Colombia",
      colombia_desc: "Azúcar de caña blanca, morena y orgánica del Valle del Cauca; café Arábica lavado de Huila, Nariño y Antioquia.",
      peru: "Perú",
      peru_desc: "Café y cacao orgánicos certificados de Cajamarca, San Martín y Junín. Trazables por lote.",
      ecuador: "Ecuador",
      ecuador_desc: "Cacao fino de aroma Nacional y CCN-51 de Manabí y Esmeraldas.",
      dominican: "República Dominicana",
      dominican_desc: "Cacao Hispaniola premium, fermentación lenta y secado natural al sol.",
    },
    logistics: {
      eyebrow: "Logística",
      title: "Transporte marítimo. MSC como único partner.",
      lead: "Confiamos todos los embarques a la red global de MSC: frecuencia, cobertura y, sobre todo, puntualidad documentada.",
      point1_title: "Booking directo",
      point1_desc: "Acceso prioritario a salidas semanales desde Cartagena, Buenaventura, Callao, Guayaquil y Caucedo.",
      point2_title: "Tracking integral",
      point2_desc: "Visibilidad del contenedor 24/7 hasta el puerto europeo o mediterráneo.",
      point3_title: "Documentación conforme",
      point3_desc: "Fitosanitario, Certificado de Origen, EUR.1, ISO/HACCP: todo gestionado internamente.",
    },
    certifications: {
      eyebrow: "Garantías de calidad",
      title: "Certificaciones de máxima calidad.",
      lead: "Cada lote está respaldado por certificaciones internacionales de sostenibilidad, seguridad alimentaria y trazabilidad. Nuestra red de productores opera con los estándares más exigentes del sector.",
      items: [
        { code: "EU ORGANIC", desc: "Cadena orgánica certificada según el reglamento europeo." },
        { code: "USDA ORGANIC", desc: "Estándar orgánico de EE. UU. para exportación a Norteamérica." },
        { code: "FAIRTRADE", desc: "Comercio justo con precio garantizado al productor." },
        { code: "BONSUCRO", desc: "Estándar global para la caña de azúcar sostenible." },
        { code: "RAINFOREST ALLIANCE", desc: "Protección de ecosistemas tropicales y de los trabajadores." },
        { code: "ISO 22000 / HACCP", desc: "Gestión integral de la seguridad alimentaria." },
        { code: "FSSC 22000", desc: "Esquema de certificación reconocido por GFSI." },
        { code: "SMETA · SEDEX", desc: "Auditoría ética sobre trabajo, ambiente e integridad." },
      ],
    },
    about: {
      eyebrow: "Nosotros",
      title: "Un trader, no un intermediario.",
      body1: "World Commodity Supply nace para acortar la distancia entre las plantaciones de Colombia, Perú, Ecuador y República Dominicana y la industria alimentaria europea. Sin cadena de intermediarios: solo relación directa con los productores que elegimos.",
      body2: "Nuestro equipo combina traders de commodities, expertos en trade finance y especialistas en logística marítima. Trabajamos en tres idiomas y tres continentes con un único principio: entregar lo prometido, el día prometido.",
    },
    contact: {
      eyebrow: "Solicitud de cotización",
      title: "Hablemos de su próximo embarque.",
      lead: "Complete el formulario: recibirá una oferta CIF/FOB con lead time y disponibilidad en un plazo de 48 horas laborables.",
      company: "Empresa",
      contact_name: "Nombre de contacto",
      email: "Email",
      phone: "Teléfono (opcional)",
      country: "País",
      destination_port: "Puerto de destino",
      product: "Producto",
      quantity: "Cantidad (toneladas métricas)",
      incoterm: "Incoterm",
      message: "Notas adicionales",
      submit: "Enviar solicitud",
      sending: "Enviando...",
      success_title: "Solicitud recibida",
      success_desc: "Gracias. Nuestro equipo responderá en un plazo de 48 horas laborables.",
      error_title: "Error",
      error_desc: "No fue posible enviar la solicitud. Inténtelo nuevamente en unos instantes.",
      select_product: "Seleccione un producto",
    },
    footer: {
      tagline: "Materias primas sudamericanas. Logística MSC. Promesas cumplidas.",
      copyright: "© 2025 World Commodity Supply. Todos los derechos reservados.",
      sections: "Secciones",
      contact_title: "Contacto",
      contact_lead: "Escríbenos para cotizaciones, muestras o alianzas comerciales.",
      legal: "Legal",
      privacy: "Privacidad",
      terms: "Términos",
    },
    admin: {
      login_title: "Acceso administrador",
      email: "Email",
      password: "Contraseña",
      sign_in: "Acceder",
      signing_in: "Accediendo...",
      invalid: "Credenciales no válidas",
      dashboard: "Panel de cotizaciones",
      logout: "Salir",
      filter_all: "Todas",
      filter_new: "Nuevas",
      filter_review: "En revisión",
      filter_archived: "Archivadas",
      mark_review: "Marcar en revisión",
      mark_archived: "Archivar",
      mark_new: "Reabrir",
      no_quotes: "Sin solicitudes en esta categoría.",
      company: "Empresa",
      product: "Producto",
      quantity: "Cantidad",
      country: "País",
      received: "Recibida",
      status: "Estado",
      details: "Detalles",
    },
  },
};
